// Runtime configuration is embedded at build-time by Vue CLI via VUE_APP_* env vars.
// See .env / prod.env / .env.example for available keys.

export const ADDRESS: string =
  process.env.VUE_APP_API_URL || "https://tuthaiamulet.com/api/v1";

export const APIKEY: string =
  process.env.VUE_APP_API_KEY || "";

export const FILE_BASE: string =
  process.env.VUE_APP_FILE_BASE || ADDRESS.replace("/api/v1", "");

// Kept for backward compatibility with existing imports.
export const filePath: string = FILE_BASE;

export const FACEBOOK_URL: string =
  process.env.VUE_APP_FACEBOOK_URL ||
  "https://www.facebook.com/profile.php?id=100091318575723";

/**
 * Returns a displayable image URL routed through the backend presign proxy.
 * - Backend GET /file?key=... generates a presigned S3 URL (1 hr) and redirects.
 * - If `path` is already a full URL (legacy / external), returns it as-is.
 */
export function imageUrl(path?: string | null): string {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${ADDRESS}/file?key=${encodeURIComponent(path)}`;
}

export default ADDRESS;
